export default "__VITE_ASSET__1bdad5c1__"